(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2618],{

/***/ 32053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ use_cases; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../libs/templates/Navigation2/index.ts + 91 modules
var Navigation2 = __webpack_require__(92609);
// EXTERNAL MODULE: ../../libs/templates/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(34810);
// EXTERNAL MODULE: ../../libs/api/routes/useCases/queries/index.ts + 3 modules
var queries = __webpack_require__(95092);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/Hero/Hero.tsx





var copy = {
  overline: "Use Cases",
  heading: "Empower every team <br>with good data"
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroUseCaseBase, {
      variant: "centered",
      copyVariant: "wide",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            variant: "h5",
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            dangerouslySetInnerHTML: {
              __html: copy.heading
            }
          })]
        })
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1w681ev1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroUseCaseBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1w681ev0"
} : 0)(recipes_Hero/* Wrapper */.im, "{", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:80px;padding-bottom:80px;}}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/Filters/FilterSelect.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var FilterSelect = function FilterSelect(_ref) {
  var options = _ref.options,
      id = _ref.id,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled;
  var appearance = (0,AppearanceContext/* useAppearance */.M)();

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      multiselect: true,
      mobileConfirmationBehaviour: true
    }
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FilterSelect_Wrapper, {
    appearance: appearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small"
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: placeholder,
      counter: true
    })), {}, {
      "aria-label": placeholder,
      disabled: disabled
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: "select-base-".concat(id),
      name: "select-base-".concat(id),
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open,
      listItemComponent: Select/* MenuItemWithCheckbox */.N1
    }, getSelectProps()))]
  });
};

/* harmony default export */ var Filters_FilterSelect = (FilterSelect);

var FilterSelect_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecre95t0"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme,
      appearance = _ref2.appearance;
  return appearance === "dark" && theme.palette.brand.darkAcai[700];
}, ";color:", function (_ref3) {
  var theme = _ref3.theme,
      appearance = _ref3.appearance;
  return appearance === "dark" ? theme.palette.neutrals.white[100] : theme.palette.twilio.gray[80];
}, ";z-index:1;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/Filters/Filters.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var Filters_copy = {
  description: "Discover what you are looking for by filtering use cases:"
};

var toOptionProps = function toOptionProps(filter) {
  var title = filter.title;
  return {
    value: title,
    text: title
  };
};

var Filters = function Filters(_ref) {
  var filters = _ref.filters,
      _ref$onFilterChange = _ref.onFilterChange,
      onFilterChange = _ref$onFilterChange === void 0 ? function () {
    return null;
  } : _ref$onFilterChange;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
        tag: "p",
        variant: "pMedium",
        tokens: {
          color: theme.palette.twilio.gray[60]
        },
        children: Filters_copy.description
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        gap: "small",
        columns: 1,
        overrides: {
          lg: filters === null || filters === void 0 ? void 0 : filters.length
        },
        children: filters === null || filters === void 0 ? void 0 : filters.map(function (_ref2) {
          var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
              key = _ref3[0],
              filter = _ref3[1];

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_FilterSelect, {
            id: key,
            placeholder: filter.title,
            options: filter.items.map(toOptionProps),
            onSelect: function onSelect(selectedOptions) {
              return onFilterChange(key, selectedOptions);
            }
          }, key);
        })
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1fqtpel2"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{justify-content:unset;padding-top:24px;padding-bottom:40px;row-gap:24px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding-top:40px;}}" + ( true ? "" : 0));

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1fqtpel1"
} : 0)( true ? {
  name: "2cp9od",
  styles: "margin:8px"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1fqtpel0"
} : 0)("max-width:520px;row-gap:8px;margin:0 auto;margin-bottom:8px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xl");
}, "{padding:0 80px;}" + ( true ? "" : 0));

/* harmony default export */ var Filters_Filters = (Filters);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/hooks/useFilters.ts



function useFilters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFilters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFilters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFilters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var useFilters = function useFilters(entries) {
  var _useState = (0,react.useState)(useFilters_objectSpread({}, entries.reduce(function (acc, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
        key = _ref2[0];

    return useFilters_objectSpread(useFilters_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, []));
  }, {}))),
      filtersState = _useState[0],
      setFiltersState = _useState[1];

  var createHandler = function createHandler(key, setState) {
    return function (selected) {
      return setState(function (prev) {
        return useFilters_objectSpread(useFilters_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, selected));
      });
    };
  };

  var selectHandlers = entries.reduce(function (acc, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
        key = _ref4[0];

    return useFilters_objectSpread(useFilters_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, createHandler(key, setFiltersState)));
  }, {});
  return {
    filtersState: filtersState,
    selectHandlers: selectHandlers
  };
};
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var recipes_Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/Card/Card.tsx









var Card = function Card(_ref) {
  var title = _ref.title,
      description = _ref.description,
      url = _ref.url,
      useCase = _ref.useCase;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* default */.ZP, {
    href: (0,getAbsoluteUrl/* default */.Z)("/use-cases/".concat(url), pageConfig),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Body */.uT, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Accessories */.v8, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* AccessoriesRow */.OW, {
          children: useCase === null || useCase === void 0 ? void 0 : useCase.map(function (use, key) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
              variant: "outlined",
              children: use
            }, key);
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Card/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Headline */.s0, {
          tag: "h2",
          children: title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Description */.dk, {
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Card/* Action */.aU, {
        alignment: "left",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "See available recipes"
        })
      })]
    })
  });
};

/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/CardsGroup/CardsGroup.tsx


var _excluded = ["children"];

function CardsGroup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsGroup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsGroup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsGroup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CardsGroup = function CardsGroup(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, CardsGroup_objectSpread(CardsGroup_objectSpread({
    columns: 1,
    overrides: {
      lg: 3
    }
  }, rest), {}, {
    children: children
  }));
};

/* harmony default export */ var CardsGroup_CardsGroup = (CardsGroup);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/CardsSection/CardsSection.tsx



var CardsSection_excluded = ["children"];

function CardsSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CardsSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardsSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardsSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var CardsSection = function CardsSection(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, CardsSection_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsSection_StyledSectionBase, CardsSection_objectSpread(CardsSection_objectSpread({
    variant: "noCopy"
  }, rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: children
    })
  }));
};

var CardsSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "egzidql0"
} : 0)(function (_ref2) {
  var isEmpty = _ref2.isEmpty;
  return isEmpty && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(Section/* Wrapper */.im, "{padding-top:40px;padding-bottom:40px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CardsSection_CardsSection = (CardsSection);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/UseCasesGrid/UseCasesGrid.tsx







var UseCasesGrid = function UseCasesGrid(_ref) {
  var useCases = _ref.useCases;
  var isEmpty = !useCases || useCases.length === 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsSection_CardsSection, {
    isEmpty: isEmpty,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsGroup_CardsGroup, {
      "data-testid": "cards-grid",
      "aria-live": "polite",
      children: useCases === null || useCases === void 0 ? void 0 : useCases.map(function (_ref2) {
        var title = _ref2.title,
            useCase = _ref2.useCase,
            description = _ref2.description,
            url = _ref2.url;
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_Card, {
          useCase: useCase,
          title: title,
          description: description,
          url: url
        }, title);
      })
    }), isEmpty && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
      centered: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
        tag: "h4",
        variant: "h4",
        children: "Sorry, no results found."
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
        tag: "p",
        variant: "pMedium",
        children: "Please try selecting different filters."
      })]
    })]
  });
};

/* harmony default export */ var UseCasesGrid_UseCasesGrid = (UseCasesGrid);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/components/GettingStarted/GettingStarted.tsx











var data = {
  heading: "Getting started is easy",
  description: "Start connecting your data with Segment"
};

var BaseGettingStarted = function BaseGettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GettingStarted_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          children: data.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          dangerouslySetInnerHTML: {
            __html: data.description
          }
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "outlined",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  });
};

/* harmony default export */ var GettingStarted = (BaseGettingStarted);
var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewyu2n52"
} : 0)("overflow-y:auto;overflow-x:hidden;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewyu2n51"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:40px 20px 0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewyu2n50"
} : 0)("display:grid;max-width:520px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/utils/useNextPageTrigger/index.ts + 1 modules
var useNextPageTrigger = __webpack_require__(78299);
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/hooks/useUseCasesGrid.ts


function useUseCasesGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useUseCasesGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useUseCasesGrid_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useUseCasesGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var useUseCasesGrid = function useUseCasesGrid(filtersState, triggerComponent) {
  var _data$pages$length;

  var _useUseCasesQuery = (0,queries/* useUseCasesQuery */.rv)({
    args: [useUseCasesGrid_objectSpread({}, filtersState)]
  }),
      data = _useUseCasesQuery.data,
      isLoading = _useUseCasesQuery.isLoading,
      hasNextPage = _useUseCasesQuery.hasNextPage,
      fetchNextPage = _useUseCasesQuery.fetchNextPage,
      error = _useUseCasesQuery.error,
      isFetchingNextPage = _useUseCasesQuery.isFetchingNextPage;

  var pages = (0,react.useMemo)(function () {
    var _data$pages$flatMap, _data$pages;

    return (_data$pages$flatMap = data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.flatMap(function (collection) {
      var _collection$items;

      return (_collection$items = collection === null || collection === void 0 ? void 0 : collection.items) !== null && _collection$items !== void 0 ? _collection$items : [];
    })) !== null && _data$pages$flatMap !== void 0 ? _data$pages$flatMap : [];
  }, [data === null || data === void 0 ? void 0 : data.pages]);
  var nextPageTrigger = (0,useNextPageTrigger/* default */.Z)({
    isLoading: isLoading,
    totalDownloadedPages: (_data$pages$length = data === null || data === void 0 ? void 0 : data.pages.length) !== null && _data$pages$length !== void 0 ? _data$pages$length : -1,
    hasNextPage: hasNextPage,
    error: error,
    onNextPage: function onNextPage() {
      fetchNextPage();
    },
    loadMargin: "0%",
    NextPageTrigger: triggerComponent
  });
  return {
    pages: pages,
    isLoading: isLoading,
    nextPageTrigger: nextPageTrigger,
    isFetchingNextPage: isFetchingNextPage,
    hasNextPage: hasNextPage
  };
};
;// CONCATENATED MODULE: ./src/views/UseCases/LandingPage/UseCases.tsx


function UseCases_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var UseCases_copy = {
  pageTitle: "Twilio Segment Use Cases",
  pageDescription: "Explore top use cases for Twilio Segment and the tools that power them. Implement Segment once, integrate 250+ tools with the flip of a switch, and unlock thousands of new uses cases for marketing, personalization, analytics, and more."
};

var UseCasesView = function UseCasesView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useFiltersQuery = (0,queries/* useFiltersQuery */.s_)({
    args: []
  }),
      filters = _useFiltersQuery.data;

  var groupedFilterEntries = Object.entries(filters || {});

  var _useFilters = useFilters(groupedFilterEntries),
      filtersState = _useFilters.filtersState,
      selectHandlers = _useFilters.selectHandlers;

  var _useUseCasesGrid = useUseCasesGrid(filtersState),
      pages = _useUseCasesGrid.pages,
      nextPageTrigger = _useUseCasesGrid.nextPageTrigger,
      isLoading = _useUseCasesGrid.isLoading,
      hasNextPage = _useUseCasesGrid.hasNextPage,
      isFetchingNextPage = _useUseCasesGrid.isFetchingNextPage;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: UseCases_copy.pageTitle,
      pageDescription: UseCases_copy.pageDescription,
      bodyBackground: theme.palette.neutrals.white[100],
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation2/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_Filters, {
          filters: groupedFilterEntries,
          onFilterChange: function onFilterChange(filterId, selectedOptions) {
            return selectHandlers[filterId](selectedOptions);
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UseCases_Wrapper, {
          children: [!isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseCasesGrid_UseCasesGrid, {
            useCases: pages
          }), isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
          }), hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
            compensateTopGutter: hasNextPage,
            children: isFetchingNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
          }), nextPageTrigger]
        }), !hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted, {})]
      }), !hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var UseCases = (UseCasesView);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e4a0wnw2"
} : 0)( true ? "" : 0);

var UseCases_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4a0wnw1"
} : 0)( true ? "" : 0);

var _ref =  true ? {
  name: "ccki3e",
  styles: "padding:0;margin-top:-160px"
} : 0;

var LoaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e4a0wnw0"
} : 0)("display:grid;align-items:center;justify-content:center;height:400px;padding:80px 0;margin:0 auto;", function (_ref2) {
  var compensateTopGutter = _ref2.compensateTopGutter;
  return compensateTopGutter && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
;// CONCATENATED MODULE: ./src/pages/use-cases/index.tsx





var UseCasesPage = function UseCasesPage() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseCases, {})
  });
};

var __N_SSG = true;
/* harmony default export */ var use_cases = (UseCasesPage);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 16046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useIntersectionObserver_useIntersectionObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useEventCallback/index.ts
var useEventCallback = __webpack_require__(93026);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/useIntersectionObserver.ts



var isRef = function isRef(ref) {
  return typeof ref !== "string";
};

var validSelector = function validSelector(slug) {
  var selector = slug.trim();

  if (selector && selector.match(/^\d/)) {
    selector = selector.replace(/^[0-9]+/, "");
    selector = selector.startsWith("-") ? selector.replace("-", "") : selector;
  }

  return selector;
};
/**
 * A hook to observe elements in the viewport
 * @param refs - An array of refs or selectors
 * @param callback - The function to call when an element is intersecting
 * @param options - The options for the IntersectionObserver
 * @returns An object containing the update function to update the observed elements and the observer reference
 */


var useIntersectionObserver = function useIntersectionObserver(refs, callback, options) {
  var observerRef = (0,react.useRef)();
  var currentlyObserved = (0,react.useRef)(Array.from({
    length: refs.length
  }).fill(null));

  var _useState = (0,react.useState)(0),
      updateCount = _useState[0],
      setUpdateCount = _useState[1];

  var callbackHandle = (0,useEventCallback/* default */.Z)(callback, []);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(callbackHandle, options);
    observerRef.current = intersectionObserver;
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (element && currentlyObserved.current) {
        intersectionObserver.observe(element);
        currentlyObserved.current[index] = element;
      }
    });
    return function () {
      intersectionObserver.disconnect();
      currentlyObserved.current = null;
    };
  }, [updateCount, callbackHandle]);
  var update = (0,react.useCallback)(function () {
    return setUpdateCount(function (state) {
      return ++state;
    });
  }, []); // Update observed element
  // JSX is changing and observed element can be mounted and unmounted from jsx tree
  // This effect takes care of updating currently observed element to newest reference value

  (0,react.useEffect)(function () {
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (observerRef.current && currentlyObserved.current) {
        var areDifferent = currentlyObserved.current[index] !== element;

        if (currentlyObserved.current[index] && areDifferent && isRef(ref)) {
          var _observerRef$current;

          (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 ? void 0 : _observerRef$current.unobserve(currentlyObserved.current[index]);
          currentlyObserved.current[index] = null;
        }

        if (areDifferent && element && isRef(ref)) {
          var _observerRef$current2;

          (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 ? void 0 : _observerRef$current2.observe(element);
          currentlyObserved.current[index] = element;
        }
      }
    });
  });
  return {
    observerRef: observerRef,
    update: update
  };
};

/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = (useIntersectionObserver);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/index.ts


/***/ }),

/***/ 78299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useNextPageTrigger_useNextPageTrigger; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useIntersectionObserver/index.ts + 1 modules
var useIntersectionObserver = __webpack_require__(16046);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/useNextPageTrigger.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




/**
 * A hook that triggers the next page when the element is in view.
 * @param props.isLoading Whether the next page is loading.
 * @param props.onNextPage The function to call when the next page should be loaded.
 * @param props.loadMargin The margin to use when loading the next page.
 * @param props.totalDownloadedPages The total number of downloaded pages.
 * @param props.hasNextPage Whether there is a next page.
 * @param props.error The error that occurred while loading the next page.
 * @param props.NextPageTrigger The component to render as the next page trigger.
 * @returns The React component to render as the next page trigger.
 */

var useNextPageTrigger = function useNextPageTrigger(_ref) {
  var isLoading = _ref.isLoading,
      onNextPage = _ref.onNextPage,
      loadMargin = _ref.loadMargin,
      pageLength = _ref.totalDownloadedPages,
      hasNextPage = _ref.hasNextPage,
      error = _ref.error,
      _ref$NextPageTrigger = _ref.NextPageTrigger,
      NextPageTrigger = _ref$NextPageTrigger === void 0 ? DefaultNextPageTrigger : _ref$NextPageTrigger;
  var nextPageTriggerRef = (0,react.useRef)(null);
  var isInView = (0,react.useRef)(false);
  (0,useIntersectionObserver/* default */.Z)([nextPageTriggerRef], function (intersections) {
    var isInViewValue = intersections.some(function (i) {
      return i.isIntersecting;
    });
    isInView.current = isInViewValue;

    if (isLoading) {
      return;
    }

    if (isInViewValue && hasNextPage) {
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    }
  }, {
    rootMargin: loadMargin,
    threshold: [1]
  });
  (0,react.useEffect)(function () {
    if (!isLoading && isInView.current && hasNextPage) {
      // eslint-disable-next-line no-warning-comments
      // TODO: This `onNextPage()` call should be revisited since it is fetching pagination data twice
      // check out on /customers, /recipes, /catalog, /growth-masters/curriculum
      // Maybe we should remove this useEffect entirely and refactor this hook.
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoading, pageLength, hasNextPage]); // Split it to simplify typescript compilation

  var El = NextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(El, {
    ref: nextPageTriggerRef,
    error: error
  });
};

/* harmony default export */ var useNextPageTrigger_useNextPageTrigger = (useNextPageTrigger);

var DefaultNextPageTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11u9tnv0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/index.ts


/***/ }),

/***/ 77725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases",
      function () {
        return __webpack_require__(32053);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,8943,7802,6234,4136,2073,6784,8392,5735,2429,2609,948,8187,442,4881,6818,2269,9774,2888,179], function() { return __webpack_exec__(77725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);